import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { format, parseISO, add } from 'date-fns';
import { bindActionCreators, compose } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';


import PurchaseModal from '../../containers/PurchaseModal';
import ModalDtv from '../../components/Modals';

import { translate } from '../Translate';
import { getImagePath, shouldApplyCouponToShoppingCart } from '../../utils';
import { requestAsync } from '../../queries/actions';
import { selectClient } from '../../global-selectors';
import { selectUserData } from '../../queries/selectors/user';
import { updatePlanSubscription, upgradeAddOnSubscriptions } from '../../queries/subscription';
import { getProductsToBuy } from '../../queries/selectors/shoppingCart';
import { selectAddOnSubscriptions, selectCouponApply, selectSubscriptionList } from '../../queries/selectors/bootstrap';
import { selectCurrentPaymentMethod } from '../../queries/selectors/payment';
import { selectActivePlanSubscription, selectProducts } from '../../queries/selectors/products';
import { changeFavoritePaymentMethod } from '../../queries/paymentMethods';
import { addExpirationDate, hasAllUrns } from '../../utils/products';
import { PaymentGateways, ProductType } from '../../enums';
import {getCustomerBySubscriber} from "../../queries/customer";
import { languageDates } from '../../utils/validations';
import { injectGoogleFbTags } from '../../utils/tags';

const isEventOrAddOnProduct = product =>
  Boolean(product) &&
  (Boolean(product.event) || product.productType === ProductType.ADD_ON);

const getChangePlanModalDateFormat = language =>
  languageDates.includes((language || '').toLowerCase()) ? 'dd/MM/yy' : 'LL/dd/yyyy';

const getDatesForChangePlanModalBody = (product, language) => {
  if (!product) return { date1: '', date2: '' };
  const fmt = getChangePlanModalDateFormat(language);
  const hasEventBroadcastRange =
    product.event &&
    product.broadcastingDates?.start &&
    product.broadcastingDates?.end;

  if (hasEventBroadcastRange) {
    return {
      date1: format(new Date(product.broadcastingDates.start), fmt),
      date2: format(new Date(product.broadcastingDates.end), fmt),
    };
  }

  const expiresAt = addExpirationDate(product)?.expiresAt;
  return {
    date1: format(new Date(), fmt),
    date2: expiresAt
      ? format(Date.parse(expiresAt) - 24 * 60 * 60 * 1000, fmt)
      : '',
  };
};

const AddOnPurchase = (props) => {
  const {
    intl, client, upgradeAddOnSubscriptions, productsToBuy, userData, userPlan, products, addOnSubscriptions,
    modalAddExtra, setModalAddExtra, userPaymentMethod, setUserPaymentMethod, history, subscriptions,
    updatePlanSubscription, couponApplied
  } = props;
  const [modalPurchase, setModalPurchase] = useState(null);
  const [blockModalProcess, setBlockModalProcess] = useState(false);
  const querystring = window.location.search;
  const params = new URLSearchParams(querystring);

  const alertSVG = getImagePath('ic_alert.svg', client);
  const approvedSVG = getImagePath('ic_approved.svg', client);
  const rejectedSVG = getImagePath('ic_rejected.svg', client);
  const language = params.get('language');
  const onAddExtraAddOns = async () => {
    const name = `${userData.data?.name} ${userData.data?.lastname}`
    let customerResponse;
    try {
      customerResponse = await props.getCustomerBySubscriber(
          {
            name,
            paymentMethod: PaymentGateways.stripe
          })
    } catch (err) {
      throw err.message;
    }

    userPaymentMethod.payer = userPaymentMethod.payer.customerId ? userPaymentMethod.payer :
        {...userPaymentMethod.payer, customerId: customerResponse?.body?.customerId};
    const { methodInfo, paymentMethod } = userPaymentMethod;

    const paymentMethodToken = methodInfo.card_id;
    const paymentMethodId = paymentMethodToken ? methodInfo.brand : methodInfo.paymentMethodId;
    const paymentInfo = {
      paymentMethodId: paymentMethodId,
      paymentMethodType: methodInfo.paymentMethodType,
      paymentMethodFlow: methodInfo.paymentMethodFlow,
      payer: userPaymentMethod.payer,
      ...(shouldApplyCouponToShoppingCart(couponApplied, { productsToBuy }) && {
        couponCode: couponApplied.code,
      }),

      token: paymentMethodToken,
      country: userData.country,
    };

    try {
      let func, data;
      const plan = productsToBuy.find(p => p.productType === 'plan');
      if (plan) {
        paymentInfo.updatePlan = [plan.productID];
        func = updatePlanSubscription;
        data = { paymentInfo, token: userData.token, subscriptions, products, methodId: paymentMethod }
      } else {
        paymentInfo.purchaseAddOns = productsToBuy?.map(pkg => pkg.productID);
        func = upgradeAddOnSubscriptions;
        data = { paymentInfo, addOnSubscriptions, products, token: userData.token, methodId: paymentMethod, canceledProducts: [] }
      }

      const { status, body } = await func(data);
      if (status === 200) {
        if (props.forceToChangeToFavorite) {
          await props.changeFavoritePaymentMethod({
            token: props.userData.token,
            paymentMethod,
            id: userPaymentMethod._id
          })
        }
        if (body?.gatewayResponse?.redirect_url) {
          window.location.href = body.gatewayResponse.redirect_url;
        } else {
          if (status <= 300) {
            injectGoogleFbTags(plan)
          }
          setModalPurchase({
            code: status,
            transaction: body?.transaction,
            img: status >= 300 ? alertSVG : approvedSVG,
            default: status >= 300 ? 'error' : 'default',
            handleClick: () => {
              setModalPurchase(null)
              if (status <= 300) {
                history.replace(`/${client}/subscribe/subscriptions/myaccount${history.location.search}`)
              }
            },
            handleCloseModal: () => { history.replace(`/${client}/subscribe/subscriptions/myaccount${history.location.search}`) }
          });
          setModalAddExtra(false);
        }
      } else {
        setModalPurchase({
          code: 300,
          img: rejectedSVG,
          default: 'error',
          handleClick: () => {
            setModalPurchase(false)
          },
          handleCloseModal: () => { setModalPurchase(false) }
        });
        setModalAddExtra(false);
        setBlockModalProcess(false);
      }
    } catch (err) {
      setModalPurchase({
        code: 300,
        img: alertSVG,
        default: 'error',
        handleClick: () => {
          setModalPurchase(null)
        },
        handleCloseModal: () => { setModalPurchase(null) }
      });
      setModalAddExtra(false);
      setBlockModalProcess(false);
    };
  }

  const onCancelExtraAddons = () => {
    setModalAddExtra(false);
    setUserPaymentMethod(null);
  }
  const eventOrAddOnProducts = (productsToBuy || []).filter(isEventOrAddOnProduct);
  const productsForChangePlanModalBody =
    eventOrAddOnProducts.length > 0
      ? eventOrAddOnProducts
      : productsToBuy?.[0]
        ? [productsToBuy[0]]
        : [];
        
  return (
    <>
      <ModalDtv
        title={translate(intl, 'SubscriptionManagement.changePlan.modal.title')}
        isOpenModal={modalAddExtra}
        onToggleModal={onCancelExtraAddons}
        description={
          <>
            {!hasAllUrns(productsToBuy[0], userData) ? (
              <>
                {productsForChangePlanModalBody.map((product, idx) => {
                  const { date1, date2 } = getDatesForChangePlanModalBody(
                    product,
                    language
                  );
                  return (
                    <p
                      key={product._id || product.productID || idx}
                      className={idx < productsForChangePlanModalBody.length - 1 ? 'mb-3' : undefined}
                    >
                      <FormattedMessage
                        id="SubscriptionManagement.changePlan.modal.body"
                        values={{ date1, date2, planName: product.productType === ProductType.PLAN ? '' : product.name }}
                      />
                    </p>
                  );
                })}
              </>
            ) : (
              <FormattedMessage
                  id="SubscriptionManagement.changePlan.modal.body"
                  values={{
                    date1: userPlan?.expiresAt ? format(parseISO(userPlan?.expiresAt),
                    languageDates.includes(language.toLowerCase()) ? 'dd/MM/yy' : 'LL/dd/yyyy') : '',
                    planName: '',
                    date2: userPlan?.expiresAt ? format(add(Date.parse(userPlan?.expiresAt) - 24 * 60 * 60 * 1000, { [productsToBuy[0].interval.unit + 's']: productsToBuy[0]?.interval?.amount }),
                    languageDates.includes(language.toLowerCase()) ? 'dd/MM/yy' : 'LL/dd/yyyy') : ''
                  }} />
            )}
          </>
        }
        primaryButton={{
          text: translate(intl, 'SubscriptionManagement.addExtraCancel'),
          onClick: () => { 
            if (!blockModalProcess) {
              setModalAddExtra(false);
            }
            return;
          }
        }}
        secondaryButton={{
          text: translate(intl, 'SubscriptionManagement.addExtra'),
          onClick: () => {
            setBlockModalProcess(true);
            onAddExtraAddOns();
          },
          disabled: blockModalProcess
        }}
      />
      {modalPurchase && (
        <PurchaseModal
          isOpenModal={Boolean(modalPurchase)}
          onToggleModal={false}
          code={modalPurchase?.code}
          transaction={modalPurchase?.transaction}
          image={modalPurchase?.img && (
            <img
              className="PaymentStatus__img"
              src={modalPurchase?.img}
              alt="modal payment status"
            />
          )}
          title={
            <FormattedMessage
              id={`PaymentStatus.subscription.messages.${modalPurchase?.code}.title`}
              defaultMessage={translate(intl, `PaymentStatus.subscription.messages.${modalPurchase?.default}.title`)}
            />
          }
          description={
            <FormattedMessage
              id={`PaymentStatus.subscription.messages.${modalPurchase?.code}.body`}
              defaultMessage={translate(intl, `PaymentStatus.subscription.messages.${modalPurchase?.default}.body`)}
            />
          }
          errorDescription={
            <FormattedMessage
              id="PaymentStatus.subscription.messages.default.status"
              defaultMessage={translate(intl, `PaymentStatus.subscription.buttons.${modalPurchase?.default}.submit`)}
              values={{ code: modalPurchase?.code || 'unknown' }}
            />
          }
          activateButton={{
            isNeutral: false,
            text: ({
              unlinked: translate(intl, 'PaymentStatus.subscription.buttons.default.submit.unlinked'),
              linked: translate(intl, 'PaymentStatus.subscription.buttons.default.submit.linked')
            })
          }}
          secondaryButton={{
            text: (
              <FormattedMessage
                id={`PaymentStatus.subscription.buttons.${modalPurchase?.code}.submit`}
                defaultMessage={translate(intl, `PaymentStatus.subscription.buttons.${modalPurchase?.default}.submit`)}
              />
            ),
            onClick: () => { modalPurchase.handleClick() }
          }}
        />
      )}
    </>
  )
}

AddOnPurchase.propTypes = {
  intl: PropTypes.object.isRequired,
  client: PropTypes.string.isRequired,
  upgradeAddOnSubscriptions: PropTypes.func.isRequired,
  updatePlanSubscription: PropTypes.func.isRequired,
  productsToBuy: PropTypes.array.isRequired,
  userData: PropTypes.shape({
    token: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired
  }).isRequired,
  products: PropTypes.array,
  userPlan: PropTypes.object,
  addOnSubscriptions: PropTypes.array,
  modalAddExtra: PropTypes.bool.isRequired,
  forceToChangeToFavorite: PropTypes.bool,
  setModalAddExtra: PropTypes.func.isRequired,
  changeFavoritePaymentMethod: PropTypes.func,
  userPaymentMethod: PropTypes.object,
  couponApplied: PropTypes.object,
  setUserPaymentMethod: PropTypes.func.isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
  }).isRequired,
  subscriptions: PropTypes.array.isRequired,
  getCustomerBySubscriber: PropTypes.func,
}

const mapStateToProps = (state, props) => ({
  client: selectClient(state),
  userData: selectUserData(state),
  productsToBuy: getProductsToBuy(state),
  userPlan: selectActivePlanSubscription(state),
  methodId: selectCurrentPaymentMethod(state),
  products: selectProducts(state),
  addOnSubscriptions: selectAddOnSubscriptions(state),
  subscriptions: selectSubscriptionList(state),
  couponApplied: selectCouponApply(state),
});

const mapDispatchToProps = (
  (dispatch) => bindActionCreators({
    upgradeAddOnSubscriptions: (data) => requestAsync(upgradeAddOnSubscriptions, data),
    updatePlanSubscription: (data) => requestAsync(updatePlanSubscription, data),
    changeFavoritePaymentMethod: (data) => requestAsync(changeFavoritePaymentMethod, data),
    getCustomerBySubscriber: (data) => requestAsync(getCustomerBySubscriber, data),
  }, dispatch)
);

export default compose(
  injectIntl,
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(AddOnPurchase);
